import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";
import { registerAppServiceWorker } from "@/features/notifications/notificationClient";

registerAppServiceWorker().catch((error) => console.error("Falha ao registrar service worker do YamarHub App", error));

ReactDOM.createRoot(document.getElementById("root")!).render(<React.StrictMode><BrowserRouter><App /></BrowserRouter></React.StrictMode>);
